import apiClient from '../server/api.config';

export interface CreateEventDto {
  timestamp: string | Date;
  pass_owner_id: number;
  compagnie_id: number;
  benefit_id?: number | null;
  employee_scanning_id?: number | null;
}

interface CreateEventResponse {
  record: {
    message: string;
  };
}

export const createEvent = async (
  eventData: CreateEventDto
): Promise<CreateEventResponse> => {
  const response = await apiClient.post<CreateEventResponse>(
    '/events',
    eventData
  );
  return response.data;
};
